<div class="row mt-3 mb-3">
  <div class="col-12">
    <button (click)="adicionar()" #btnAdicionar class="btn btn-sm btn-outline-primary">
      <img src="assets/img/global/plus.png" alt="adicionar" title="Adicionar" height="16" width="16">
      Adicionar
    </button>
  </div>
</div>
<table class="table table-eddy">
  <thead>
    <tr>
      <th scope="col" style="width: 90%">Localização<span class="text-danger">*</span></th>
      <th scope="col" style="width: 90px;"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of lista">
      <td *ngIf="!item.editavel && item.id" style="width: 90%">{{item.localizacao}}</td>
      <td *ngIf="item.editavel || !item.id" style="width: 90%">
        <input id="localizacao" type="text" class="form-control font-weight-bold" [(ngModel)]="item.localizacao">
      </td>
      <td class="text-right" style="min-width: 100px;">
        <button *ngIf="item.editavel" (click)="salvar(item)" class="btn btn-sm btn-outline-secondary mr-2">
          <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel && item.id" (click)="cancelar(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
        </button>
        <button *ngIf="item.editavel && !item.id" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/cross.png" alt="remover" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel && item.id" (click)="editar(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
        </button>
        <button *ngIf="!item.editavel" (click)="remover(item)"
          class="btn btn-sm btn-outline-primary mr-2">
          <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
        </button>
      </td>
    </tr>
  </tbody>
</table>
